import { javascript } from '@codemirror/lang-javascript';
import { json } from '@codemirror/lang-json';
import ReactCodeMirror, { EditorView } from '@uiw/react-codemirror';
import { type ReactNode, forwardRef } from 'react';
import { type ExtraProps } from 'react-markdown';

import { Text } from '@notablehealth/design-system';

interface MarkdownCodeMirrorProps {
  children?: ReactNode;
  className?: string;
}

export const MarkdownCodeMirror = forwardRef<any, MarkdownCodeMirrorProps & ExtraProps>(
  (props, ref) => {
    const { className, children } = props;
    if (typeof children !== 'string') {
      return <Text ref={ref}>{children}</Text>;
    }
    const extensions = [EditorView.lineWrapping];
    if (className?.endsWith('json')) {
      extensions.push(json());
    }
    if (className?.endsWith('javascript')) {
      extensions.push(javascript());
    }
    return (
      <ReactCodeMirror
        ref={ref}
        extensions={extensions}
        value={children.trim()}
        editable={false}
        minHeight="80px"
        maxHeight="240px"
        style={{
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.23)',
        }}
      />
    );
  }
);
MarkdownCodeMirror.displayName = 'MarkdownCodeMirror';
